import React from 'react';
import { mockData } from '../mock';
import CategoryFilter from './CategoryFilter';
import ServiceCard from './ServiceCard';

const ServicesSection = () => {
  const [activeCategory, setActiveCategory] = React.useState('All Services');
  
  const categories = ['All Services', 'Housing & Living Supports', 'Personal & Daily Supports', 'Capacity Building & Employment', 'Community & Group Supports'];
  
  const filteredServices = activeCategory === 'All Services' 
    ? mockData.services 
    : mockData.services.filter(service => service.category === activeCategory);

  return (
    <section id="services" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#2C2C2A] mb-4 tracking-tight">
            Our NDIS Services
          </h2>
          <p className="text-lg text-[#6B6B69] max-w-3xl mx-auto">
            Comprehensive support services tailored to your needs and goals
          </p>
        </div>

        {/* Category Filter */}
        <CategoryFilter 
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredServices.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;